import { useState } from 'react';
import { PrescriptionPreviewModal } from './PrescriptionPreviewModal';
import { LatestPrescriptionPreview, PrescriberService } from 'src/services/prescriber';
import { useFeedbackContext } from 'src/providers/FeedbackProvider';
import { trackPrescriptionPreviewNewClick, trackPrescriptionPreviewResumeClick } from 'src/services/tracking/events';

interface PrescriptionPreviewModalWrapperProps {
  previewData: LatestPrescriptionPreview;
  prescriberId: string;
  patientId: string;
  onClose: () => void;
  onNewPrescription: () => void;
  onResumePrescription: (modalUrl: string) => void;
}

export function PrescriptionPreviewModalWrapper(props: PrescriptionPreviewModalWrapperProps) {
  const { previewData, prescriberId, patientId, onClose, onNewPrescription, onResumePrescription } = props;
  const { openToast } = useFeedbackContext();
  const [isResuming, setIsResuming] = useState(false);

  const handleNewPrescription = async () => {
    trackPrescriptionPreviewNewClick(prescriberId);
    onClose();
    onNewPrescription();
  };

  const handleResumePrescription = async () => {
    trackPrescriptionPreviewResumeClick(prescriberId);
    setIsResuming(true);
    try {
      const resumeData = await PrescriberService.resumeLatestPrescription(prescriberId, patientId);
      onClose();
      onResumePrescription(resumeData.modalUrl);
    } catch (error) {
      openToast('Erro ao retomar prescrição. Tente novamente em instantes.', {
        type: 'error',
        duration: 2000,
      });
      onClose();
    } finally {
      setIsResuming(false);
    }
  };

  return (
    <PrescriptionPreviewModal
      medicines={previewData.medicines || []}
      exams={previewData.exams || []}
      referrals={previewData.referrals || []}
      medicalCertificates={previewData.medicalCertificates || []}
      reports={previewData.reports || []}
      onNewPrescription={handleNewPrescription}
      onResumePrescription={handleResumePrescription}
      onClose={onClose}
      isLoading={isResuming}
    />
  );
}
